import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import {itIT} from '@material-ui/core/locale';
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";

const IGOR_BACKGROUND = "#F7F7F7";
// const IGOR_GRAY = "#904820";
const IGOR_GRAY = "#484848";
// const IGOR_LIGHT_GRAY = "#A4A4A4";
// const IGOR_GRAY_RGB = "rgb(72,72,72)";

const IGOR_GREEN = "#27CC89";
const IGOR_GREEN_DARK = "#1e9c69";
const IGOR_GREEN_LIGHT = "#2ce79a";
const IGOR_GREEN_RGB = "rgb(39,204,137)";


export let baseTheme = {
    "toolbar": {
        "minHeight": 56,
        "@media (min-width:0px) and (orientation: landscape)": {"minHeight": 48},
        "@media (min-width:600px)": {"minHeight": 64}
    },
    //@FIXME set to invalid value so it does not overrride the styles from makeStyles
    shadows: ["no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no", "no",],
    custom: {
        sideBarWidth: 240,
        sideBarWidthMobile: "60px",
        buttonWidth: "240px",
        buttonHeight: "48px",
        background: IGOR_BACKGROUND
    },
    card: {
        background: '#FFFFFF',
        color: 'black'
    },
    typography:
        {
            "htmlFontSize": 16,
            "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
            "fontSize": 14,
            "fontWeightLight": 300,
            "fontWeightRegular": 400,
            "fontWeightMedium": 500,
            "fontWeightBold": 700,
            "h1": {
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 300,
                "fontSize": "6rem",
                "lineHeight": 1.167,
                "letterSpacing": "-0.01562em"
            },
            "h2": {
                // Views/Title
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 600,
                "fontSize": "24px",
                "lineHeight": "29px"
            },
            "h3": {
                // EditIntegration/Title
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 600,
                "fontSize": "18px",
                "lineHeight": "150%"
            },
            "h4": {
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "14px",
                "lineHeight": "150%",
                "letterSpacing": "0.00735em"
            },
            "h5": {
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "1.5rem",
                "lineHeight": 1.334,
                "letterSpacing": "0em"
            },
            "h6": {
                // SideBar/ListAccordion
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 600,
                "fontSize": "14px",
                "lineHeight": "17px",
                "letterSpacing": "0.00938em",
                "fontStyle": "normal"
            },
            "subtitle1": {
                // Views subtitle
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "14px",
                "lineHeight": "150%",
                "color": "#484848",
                "opacity": 0.5,
                "paddingTop": "14px",
                "paddingBottom": "40px",

            },
            "subtitle2": {
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 500,
                "fontSize": "0.875rem",
                "lineHeight": 1.57,
                "letterSpacing": "0.00714em"
            },
            "body1": {
                // SideBar/ListAccordion/Collapse
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "14px",
                "lineHeight": "17px",
                "letterSpacing": "0.00938em",
            },
            "body2": {
                // Login/Link, NewIntegration
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "0.875rem",
                "lineHeight": "150%",
                "letterSpacing": "0.01071em"
            },
            "button": {
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "14px",
                "lineHeight": "150%",
                "textTransform": "uppercase"
            },
            "caption": {
                //Template SMS
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 600,
                "fontSize": "14px",
                "lineHeight": "150%"
            },
            "overline": {
                //upload image
                "fontFamily": "\"Inter\", \"Helvetica\", \"Arial\", sans-serif",
                "fontWeight": 400,
                "fontSize": "12px",
                "lineHeight": "150%",
                "letterSpacing": "0.08333em",
                "textTransform": 'none',//"uppercase"
                "opacity": 0.5
            }
        },
    palette: {
        "common": {"black": "#000", "white": "#fff"},
        "type": "light",
        "primary": {
            "main": IGOR_GREEN_RGB,
            "contrastText": "rgb(255, 255, 255)"
        },
        "secondary": {
            "main": "#ffffff",
            "light": "rgb(255, 255, 255)",
            "dark": "rgb(178, 178, 178)",
            "contrastText": IGOR_GRAY
        },
        "linkColor": {
            "main": "#FF0000",
            "contrastText": IGOR_GRAY,
            "light": "rgb(255,0,0)"
        },
        "yellow": {"main": "#ffd600", "light": "#fff8e6"},
        "error": {"main": "#EB5757", "light": "rgb(255, 69, 105)", "dark": "rgb(178, 16, 47)", "contrastText": "#fff"},
        "warning": {"light": "#ffb74d", "main": "#ff9800", "dark": "#f57c00", "contrastText": "rgba(0, 0, 0, 0.87)"},
        "info": {"light": "#64b5f6", "main": "#2196f3", "dark": "#1976d2", "contrastText": "#fff"},
        "success": {
            "igor": IGOR_GREEN,
            "light": "#81c784",
            "main": "#4caf50",
            "dark": "#388e3c",
            "contrastText": "rgba(0, 0, 0, 0.87)"
        },
        "grey": {
            "50": "#fafafa",
            "100": "#f5f5f5",
            "200": "#eeeeee",
            "300": "#e0e0e0",
            "400": "#bdbdbd",
            "500": "#9e9e9e",
            "600": "#757575",
            "700": "#616161",
            "800": "#424242",
            "900": "#212121",
            "A100": "#d5d5d5",
            "A200": "#aaaaaa",
            "A400": "#303030",
            "A700": "#616161"
        },
        "contrastThreshold": 3,
        "tonalOffset": 0.2,
        "text": {
            "primary": IGOR_GRAY,
            "secondary": IGOR_GRAY,
            "disabled": "rgba(0, 0, 0, 0.38)",
            "hint": "rgba(0, 0, 0, 0.38)"
        },
        "divider": "rgba(0, 0, 0, 0.12)",
        "background": {"paper": "#fff", "default": IGOR_BACKGROUND},
        "action": {
            "active": IGOR_GRAY,
            "hover": "rgba(0, 0, 0, 0.04)",
            "hoverOpacity": 0.04,
            "selected": "rgba(0, 0, 0, 0.08)",
            "selectedOpacity": 0.08,
            "disabled": "rgba(0, 0, 0, 0.26)",
            "disabledBackground": "rgba(0, 0, 0, 0.12)",
            "disabledOpacity": 0.38,
            "focus": IGOR_GREEN,
            "focusOpacity": 0.12,
            "activatedOpacity": 0.12
        }
    },
    overrides: {
        paccontainer: {},
        MuiTableCell: {
            root: {
                '&:last-child': {
                    borderBottom: 'none',
                }
            }
        },
        MuiTable: {
            root: {
                justifyContent: 'center',
            }
        },
        MuiCssBaseline: {
            '@global': {
                body: {
                    background: 'transparent',
                    pointerEvents: 'none',
                },
                "input.MuiInputBase-input": {
                    height: "26px!important",
                },
                ".MuiFormControl-root": {
                    background: 'white!important'
                },
                '.CalendarDay__selected_span': {
                    background: IGOR_GREEN,
                    borderColor: IGOR_GREEN_DARK
                },
                '.CalendarDay__selected_span:hover': {
                    background: IGOR_GREEN_LIGHT,
                },
                '.CalendarDay__selected': {
                    background: IGOR_GREEN_DARK,
                    borderColor: IGOR_GREEN_DARK
                },
                '.CalendarDay__selected:hover': {
                    background: IGOR_GREEN_LIGHT,
                    borderColor: IGOR_GREEN,
                },
                '.greenText': {
                    color: IGOR_GREEN,
                    fontWeight: 400,
                    fontSize: "inherit",
                    lineHeight: "150%",
                    textDecorationLine: "underline"
                },
                '.MuiButton-root': {
                    '&:hover': {
                        background: '#e0e0e0'
                    }
                },
                '.closeBtn': {
                    position: 'absolute',
                    right: '10px',
                    top: '10px'
                },
                'a': {
                    color: IGOR_GREEN,
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    '&:hover': {
                        color: IGOR_GREEN_LIGHT,
                    }
                },
            }
        },
    }
}

const theme = createMuiTheme(baseTheme, itIT);

export function createTheme(theme) {
    return createMuiTheme(theme, itIT)
};

const CenteredTextTypography = withStyles({
    root: {
        textTransform: "no",
        textAlign: "center"
    }
})(Typography);

const JustifyTextTypography = withStyles({
    root: {
        textTransform: "no",
        textAlign: "justify"
    }
})(Typography);

export {CenteredTextTypography, JustifyTextTypography}

export default theme;
